import { type FieldError } from "@/app/(site)/_components/Atoms/Inputs/errors/fieldErrorCodes"
import { errorTextClasses } from "@/app/(site)/_components/Atoms/Inputs/input-text-classes"
import { type FontStylesWithoutDot } from "@/config/fontConfig/fontStyles"
import { clsx } from "@/src/utils/clsx"

interface InputErrorsProps {
    errors: FieldError[]
    typography?: FontStylesWithoutDot
    id?: string
    className?: string
    isFocused?: boolean
}

/** One message per code, so two validators landing on the same code read as one problem. */
const byCode = (errors: FieldError[]) => [
    ...new Map(errors.map(error => [error.code, error])).values()
]

export default function InputErrors({
    errors = [],
    typography = "Trade_Gothic_Text_14_150_0_300",
    id,
    className = "",
    isFocused = false,
    ...rest
}: InputErrorsProps) {
    if (errors.length === 0) {
        return null
    }

    return byCode(errors).map(error => (
        <div
            key={error.code}
            id={id}
            data-error={error.code}
            className={clsx(
                `transition-opacity duration-100 ${isFocused ? "absolute opacity-0" : "opacity-100"}`,
                className
            )}
            {...rest}
        >
            <span
                role="alert"
                aria-live="polite"
                className={clsx("block", errorTextClasses, typography)}
            >
                {error.message}
            </span>
        </div>
    ))
}
